import { Outlet } from "react-router-dom";

const PrescriptionReferral = () => {

    return <Outlet />
}

export default PrescriptionReferral;